var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { "no-padding": "" } }),
      _vm._v(" "),
      _c("data-set-navigation-status", {
        attrs: { hasFilter: _vm.hasFilter },
        on: {
          clearFilters: function ($event) {
            return _vm.onClearFilters()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "justify-space-around": "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                "justify-space-around": "",
                "fill-height": "",
                wrap: "",
              },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md3: "", "pt-2": "" } },
                [
                  _c("data-set-navigation", {
                    on: { search: _vm.onFilterSubmit },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md9: "",
                    "pt-2": "",
                    "pl-2": "",
                  },
                },
                [
                  _c("data-set-table", {
                    attrs: {
                      files: _vm.filteredFiles,
                      loading: _vm.files.isLoading,
                      totalItems: _vm.totalItems,
                      searchLoading: _vm.searchLoading,
                    },
                    on: { addFile: _vm.showAddFileDialog },
                    model: {
                      value: _vm.pagination,
                      callback: function ($$v) {
                        _vm.pagination = $$v
                      },
                      expression: "pagination",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.addFileDialog
        ? _c(
            "div",
            [
              _c("data-set-add-file-dialog", {
                on: { refresh: _vm.onBackOrForward },
                model: {
                  value: _vm.addFileDialog,
                  callback: function ($$v) {
                    _vm.addFileDialog = $$v
                  },
                  expression: "addFileDialog",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }